import {
  GetGuardrailTreesResponse,
  GetTextGuardrailsResponse,
} from "@financial-advisory/data-access/api-types";
import { productRecommendationApi } from "./productRecommendationApi";

export const { useGetGuardrailTreesQuery, useLazyGetGuardrailTreesQuery } =
  productRecommendationApi.injectEndpoints({
    endpoints: (builder) => ({
      getGuardrailTrees: builder.query<GetGuardrailTreesResponse, void>({
        query: () => ({
          url: `/guardrail-trees`,
          method: "GET",
        }),
      }),
    }),
  });

export const { useGetTextGuardrailsQuery, useLazyGetTextGuardrailsQuery } =
  productRecommendationApi.injectEndpoints({
    endpoints: (builder) => ({
      getTextGuardrails: builder.query<GetTextGuardrailsResponse, void>({
        query: () => ({
          url: `/text-guardrails`,
          method: "GET",
        }),
      }),
    }),
  });
